// Klient-API mod Workeren (auth + config).
export async function getConfig() {
  try { const r = await fetch('/api/config'); return await r.json(); }
  // Opfind ALDRIG et dokument-id ved fejl: doc = null gør fejlen synlig i main.js
  // i stedet for at klienten redigerer i et forkert/zombie-rum (split-brain).
  catch { return { env: 'local', doc: null, mailMode: 'dev', configError: true }; }
}

export async function getSession() {
  const r = await fetch('/auth/me', { headers: { accept: 'application/json' } });
  if (r.status === 200) return r.json();
  return { authenticated: false };
}

export async function requestLink(email) {
  const r = await fetch('/auth/request', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  return r.json();
}

export async function logout() {
  await fetch('/auth/logout', { method: 'POST' });
}
